export const StethoscopeIcon = ({
  width = 24,
  height = 24,
  color = '#667085',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Headset arc */}
    <path
      d="M7 3V8C7 10.761 9.239 13 12 13C14.761 13 17 10.761 17 8V3"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Earpieces */}
    <path
      d="M6 3H8M16 3H18"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Tube from headset to chest piece */}
    <path
      d="M12 13V17.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Chest piece */}
    <circle cx="12" cy="20" r="2" stroke={color} strokeWidth="1.5" />
  </svg>
);
